import * as React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TextField } from '@mui/material';
import dayjs from 'dayjs';

const DatePickerOnly = ({ setDate, value, name }) => {
  // Only parse if value is truthy and non-empty. This prevents dayjs(undefined) or dayjs("") from falling back to today!
  const parsedDate = value ? dayjs(value) : null;

  const handleDateChange = (newDate) => {
    if (newDate && dayjs(newDate).isValid()) {
      setDate(dayjs(newDate).format('YYYY-MM-DD'));
    } else {
      setDate(null);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        format="YYYY-MM-DD"
        views={['year', 'month', 'day']}
        value={parsedDate && parsedDate.isValid() ? parsedDate : null}
        onChange={handleDateChange}
        slotProps={{
          textField: {
            size: 'small',
            fullWidth: true,
            name: name,
            placeholder: 'YYYY-MM-DD',
          }
        }}
        renderInput={(params) => (
          <TextField {...params} name={name} fullWidth size="small" placeholder="YYYY-MM-DD" />
        )}
      />
    </LocalizationProvider>
  );
};

export default DatePickerOnly;
